import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import MyContext from "../../MyContext";

const CtaSection = () => {
  const { baseUrl, config } = useContext(MyContext);

  const [plans, setPlans] = useState([]);
  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");
const navigate = useNavigate();

  // ===== SESSION ID =====
  const generateUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  useEffect(() => {
    let storedSessionID = sessionStorage.getItem("sessionID");
    if (storedSessionID) {
      setSessionId(storedSessionID);
    } else {
      const tempSessionID = generateUUID();
      sessionStorage.setItem("sessionID", tempSessionID);
      setSessionId(tempSessionID);
    }
  }, []);

  // ===== CAMPAIGN ID =====
  useEffect(() => {
    let urlParams = new URLSearchParams(window.location.search);
    let campaignid = urlParams.get("campaignid");

    if (!campaignid) {
      urlParams = new URLSearchParams(window.location.hash.substring(1));
      campaignid = urlParams.get("campaignid");
    }

    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
      setCampaignIdHook(campaignid);
    }
  }, []);

  // ===== FETCH PLANS =====
  const fetchSubscriptionPlans = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionPlans`,
        { userid: "", countryCode: "IN" },
        config
      );
      setPlans(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    if (sessionID) {
      fetchSubscriptionPlans();
    }
  }, [sessionID]);

  // ===== SEO TRACK CLICK =====
  const trackClick = async (requestBody) => {
    try {
      await axios.post(
        `${baseUrl}/api/Blog/trackClickHeatMaps`,
        requestBody
      );
      return true;
    } catch (error) {
      console.error("SEO track error:", error);
      return false;
    }
  };

  const handleButtonClick_SEO = async (buttonName) => {
    const urlParams = new URLSearchParams(window.location.search);
    const storedTrackingData =
      JSON.parse(sessionStorage.getItem("trackingData")) || {};

    const requestBody = {
      campaignid: campaignIdHook,
      sessionid: sessionID,
      element: "Button",
      button_name: buttonName,
      pageurl: window.location.href,
      pagename: "Landing Page",
      product: "Anlook",
      utm_source: urlParams.get("utm_source") || storedTrackingData.utm_source,
    };

    await trackClick(requestBody);
  };

  // ===== JSX =====
  return (
    <div className="my-landing-p2">
      <div className="my-landing-p">
        <div className="My-Landing-cta-banner">
          <div className="My-Landing-cta-text font-size-1">
            Start optimizing your business with <br /> Anlook today
          </div>

          <div className="main-responsive-flex">
            <Link
              to="/get/GetStarted"
              className="text-decoration-none Landing-btn"
              state={{ plan: plans }}
              onClick={async () => {
                await handleButtonClick_SEO("Get Started");
              }}
            >
              <div className="text-center">Get Started</div>
            </Link>

            <button
              className="Landing-btn-2"
              onClick={() => navigate("/pricing-page")}
            >
              See Pricing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
